import { render, staticRenderFns } from "./parentMessage.vue?vue&type=template&id=720fe5cc&scoped=true"
import script from "./parentMessage.vue?vue&type=script&lang=js"
export * from "./parentMessage.vue?vue&type=script&lang=js"
import style0 from "./parentMessage.vue?vue&type=style&index=0&id=720fe5cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720fe5cc",
  null
  
)

export default component.exports